import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner, Text } from '@fluentui/react-components';
import { Providers } from '@microsoft/mgt-element';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the code from URL parameters
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        if (code) {
          // Let Microsoft Graph Toolkit handle the auth callback
          if (Providers.globalProvider) {
            // The provider will handle the token exchange
            // Wait a moment for the provider to process
            await new Promise(resolve => setTimeout(resolve, 2000));

            // Check if authentication was successful
            const isSignedIn = await (Providers.globalProvider as any).getState();

            if (isSignedIn === 'SignedIn') {
              console.log('Authentication successful');
              navigate('/', { replace: true });
            } else {
              console.error('Authentication failed');
              navigate('/?auth=failed', { replace: true });
            }
          } else {
            console.error('No provider available');
            navigate('/?auth=failed', { replace: true });
          }
        } else {
          // No code, probably an error
          const error = searchParams.get('error');
          const errorDescription = searchParams.get('error_description');

          console.error('Auth callback error:', error, errorDescription);
          navigate(`/?auth=failed&error=${error}`, { replace: true });
        }
      } catch (error) {
        console.error('Error handling auth callback:', error);
        navigate('/?auth=failed', { replace: true });
      }
    };

    handleAuthCallback();
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: '16px'
    }}>
      <Spinner size="large" />
      <Text size={500}>
        Finalisation de la connexion SharePoint...
      </Text>
    </div>
  );
};

export default AuthCallback;